import PropTypes from 'prop-types';

const EventShape = PropTypes.shape({
  aboutCopy: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
  endTime: PropTypes.string,
  eventId: PropTypes.number,
  generalSaleDate: PropTypes.string,
  hasNotify: PropTypes.bool,
  images: PropTypes.arrayOf(PropTypes.string),
  isOnline: PropTypes.bool,
  isGlobalDiningAccess: PropTypes.bool,
  isPresale: PropTypes.bool,
  location: PropTypes.shape({
    address1: PropTypes.string,
    city: PropTypes.string,
    neighborhood: PropTypes.string,
    postalCode: PropTypes.string,
    state: PropTypes.string,
  }),
  maxPartySize: PropTypes.number,
  name: PropTypes.string,
  needToKnowCopy: PropTypes.string,
  notifyDate: PropTypes.string,
  notifyEndTime: PropTypes.string,
  notifyStartTime: PropTypes.string,
  phone: PropTypes.string,
  // presaleDates
  packages: PropTypes.arrayOf(PropTypes.shape({})),
  priceSummary: PropTypes.shape({
    currency: PropTypes.string,
  }),
  saleHasEnded: PropTypes.bool,
  serviceTypeId: PropTypes.number,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  time: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  venue: PropTypes.string,
  venueData: PropTypes.shape({
    neighborhood: PropTypes.string,
  }),
  venueId: PropTypes.number,
  whyWeLikeIt: PropTypes.string,
});

export default EventShape;
